/* globals policiesIndexUrl policiesCreateUrl policiesUpdateUrl policiesDeleteUrl */

import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import { Modal } from 'flowbite';

import ProcurementPoliciesEditModal from './ProcurementPoliciesEditModal';
import ProcurementPoliciesTableRow from './ProcurementPoliciesTableRow';

import { modalOptions } from 'Helpers/modalOptions';

import Button from 'CommonComponents/Button';
import ConfirmationModal from 'CommonComponents/ConfirmationModal';

import useModal from 'Hooks/useModal';

import PlusIcon from 'Assets/icons/plus.svg';

function ProcurementPoliciesTable(props) {
    const [policies, setPolicies] = useState([]);
    const [updatedPolicy, setUpdatedPolicy] = useState({});
    const [deletedPolicy, setDeletedPolicy] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [fetchUrl, setFetchUrl] = useState(props.indexUrl);

    const [actionCompleted, setActionCompleted] = useState(false);
    const [actionInProgress, setActionInProgress] = useState(false);
    const [actionFailed, setActionFailed] = useState(false);

    const [procurementPoliciesDeleteModalElement, setProcurementPoliciesDeleteModalElement] = useState(null);

    const procurementPoliciesDeleteModalRef = useRef();

    const procurementPoliciesEditModal = useModal();

    useEffect(() => {
        fetchPolicies();
        procurementPoliciesDeleteModalRef &&
            setProcurementPoliciesDeleteModalElement(new Modal(procurementPoliciesDeleteModalRef.current, modalOptions(false)));
    }, []);

    useEffect(() => {
        if (Object.keys(updatedPolicy).length > 0) {
            procurementPoliciesEditModal.show();
        }
    }, [updatedPolicy]);

    useEffect(() => {
        if (Object.keys(deletedPolicy).length > 0) {
            procurementPoliciesDeleteModalElement && procurementPoliciesDeleteModalElement.show();
        }
    }, [deletedPolicy]);

    const fetchPolicies = () => {
        setIsLoading(true);
        axios
            .untranslated()
            .get(fetchUrl)
            .then((res) => {
                setPolicies([...res.data]);
            })
            .catch((e) => {
                setPolicies([]);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    function editPolicy(policy) {
        setUpdatedPolicy(policy);
    }

    function deletePolicy(policy) {
        setDeletedPolicy(policy);
    }

    const successHandler = () => {
        setUpdatedPolicy({});
        setDeletedPolicy({});
        fetchPolicies();
        procurementPoliciesEditModal.hide();
        procurementPoliciesDeleteModalElement && procurementPoliciesDeleteModalElement.hide();

        if (props.onChanged) {
            props.onChanged();
        }
    };

    const closeModal = () => {
        setUpdatedPolicy({});
        setDeletedPolicy({});
        procurementPoliciesEditModal.hide();
        procurementPoliciesDeleteModalElement && procurementPoliciesDeleteModalElement.hide();
    };

    const cleanConfirmationModalStates = () => {
        setActionInProgress(false);
        setActionFailed(false);
        setActionCompleted(false);
    };

    const triggerDeletePolicy = () => {
        setActionInProgress(true);

        axios
            .delete(props.deleteUrl.replace('POLICY_ID', deletedPolicy.id), { data: {} })
            .then((response) => {
                setActionCompleted(true);
            })
            .catch((e) => {
                setActionFailed(true);
            });
    };

    return (
        <div className="table__card">
            <div className="tw-flex tw-items-start tw-justify-between tw-mb-6">
                <h5 className="table__header">{$t('Procurement Policies')}</h5>
                <div>
                    {props.onCreateInline ? (
                        <Button variant="primary" onClick={props.onCreateInline}>
                            <PlusIcon className="tw-w-3 tw-h-3" />
                            {$t('Add new policy step')}
                        </Button>
                    ) : (
                        <Button variant="primary" as="a" href={props.createUrl}>
                            <PlusIcon className="tw-w-3 tw-h-3" />
                            {$t('Add new policy step')}
                        </Button>
                    )}
                </div>
            </div>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th>{$t('Value')}</th>
                            <th>{$t('Method')}</th>
                            <th>{$t('Details')}</th>
                            <th className="tw-w-40">{$t('Actions')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {policies.map((policy) => {
                            return <ProcurementPoliciesTableRow key={policy.id} policy={policy} editPolicy={editPolicy} deletePolicy={deletePolicy} />;
                        })}
                    </tbody>
                </table>
                <ProcurementPoliciesEditModal
                    id={'edit-policy'}
                    modal={procurementPoliciesEditModal}
                    closeHandler={closeModal}
                    successHandler={successHandler}
                    policy={updatedPolicy}
                    policiesUpdateUrl={props.updateUrl}
                />
                <ConfirmationModal
                    closeHandler={closeModal}
                    successHandler={successHandler}
                    triggerAction={triggerDeletePolicy}
                    cleanStates={cleanConfirmationModalStates}
                    allowAction={Object.keys(deletedPolicy).length > 0}
                    modalId={'delete-policy'}
                    modalRef={procurementPoliciesDeleteModalRef}
                    modalElement={procurementPoliciesDeleteModalElement}
                    request={actionInProgress}
                    actionCompleted={actionCompleted}
                    actionFailed={actionFailed}
                    confirmationMsg={'Are you sure you want to delete ' + [deletedPolicy?.total_cost]}
                    actionCompletedMsg={[deletedPolicy?.total_cost] + ' deleted'}
                    actionFailedMsg={[deletedPolicy?.total_cost] + ' could not be deleted'}
                    title={$t('Delete Policy Step')}
                    cancelButtonText="Cancel"
                    primaryButtonText="Delete"
                />
            </div>
        </div>
    );
}

export default ProcurementPoliciesTable;

if (document.getElementById('procurementPoliciesTable')) {
    var root = document.getElementById('procurementPoliciesTable');
    ReactDOM.render(
        <App>
            <ProcurementPoliciesTable indexUrl={policiesIndexUrl} createUrl={policiesCreateUrl} updateUrl={policiesUpdateUrl} deleteUrl={policiesDeleteUrl} />
        </App>,
        root,
    );
}
